export default __webpack_public_path__ + "assets/space-force-logo.17cd4725.png";